import request from '../../../api/request';
import { TutorsResponse } from '../parts/studentTutors/types';

const TUTORS = {
  GET_TUTORS: (postulantId: string | number) =>
    `maintainers-portal/student-management/student-tutors/${postulantId}`,
  ASSIGN_TUTOR: () =>
    `maintainers-portal/student-management/student-tutors/assign-tutor/`,
};

export function getStudentTutors(studentId: number) {
  return request<TutorsResponse>(TUTORS.GET_TUTORS(studentId));
}

export function assignTutor(studyPlanEnrollmentdId: number, teacherId: number) {
  return request(TUTORS.ASSIGN_TUTOR(), {
    method: 'POST',
    data: {
      studyPlanEnrollmentdId,
      teacherId,
    },
  });
}
